export default "__VITE_ASSET__c45e9cef__"